import { Question, QuestionSet, SessionStage } from '@/types';

export interface QuestionSetGameData {
  questions: Question[];
  stages: SessionStage[];
}

const DEFAULT_BONUS_SELECTION_SECONDS = 8;

function mapPointsToMultiplier(points: Question['pointMultiplier'] | undefined | string): number {
  if (points === '2x') return 2;
  if (points === '3x') return 3;
  if (points === 'none') return 0;
  return typeof points === 'number' && Number.isFinite(points) ? points : 1;
}

export function transformQuestionSetToGameData(questionSet: QuestionSet): QuestionSetGameData {
  const orderedItems = [...questionSet.questions].sort((a, b) => a.order - b.order);

  const questions: Question[] = [];
  const stages: SessionStage[] = [];
  let questionIndex = 0;

  orderedItems.forEach(item => {
    if (item.type === 'question' && item.question) {
      const convertedQuestion: Question = {
        id: item.question.id,
        text: item.question.text,
        choices: Array.isArray(item.question.choices) ? [...item.question.choices] : [],
        correctAnswerIndex: item.question.correctAnswerIndex,
        category: item.question.category,
        difficulty: item.question.difficulty,
        pointMultiplier: mapPointsToMultiplier(item.question.points),
        questionReadingTimeSeconds: item.question.questionReadingTimeSeconds,
        arenaPlayTimeSeconds: item.question.arenaPlayTimeSeconds,
        explanation: item.question.explanation
      };

      questions.push(convertedQuestion);

      stages.push({
        id: item.id,
        type: 'question',
        question: convertedQuestion,
        questionIndex
      });

      questionIndex += 1;
    } else if (item.type === 'bonus_round' && item.bonusRound) {
      const selectionSeconds = typeof item.bonusRound.selectionTimeSeconds === 'number' && item.bonusRound.selectionTimeSeconds > 0
        ? item.bonusRound.selectionTimeSeconds
        : DEFAULT_BONUS_SELECTION_SECONDS;

      stages.push({
        id: item.id,
        type: 'bonus',
        bonusRound: {
          id: item.bonusRound.id,
          name: item.bonusRound.name,
          selectionTimeSeconds: selectionSeconds,
          availableItems: Array.isArray(item.bonusRound.availableItems)
            ? [...item.bonusRound.availableItems]
            : [],
          assignRandomly: item.bonusRound.assignRandomly ?? false,
          isActive: item.bonusRound.isActive ?? true,
          createdAt: item.bonusRound.createdAt || new Date(),
          updatedAt: item.bonusRound.updatedAt || new Date()
        }
      });
    }
  });

  return { questions, stages };
}
